import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductsPage.css";
// import CircularProgress from "@mui/material/CircularProgress";
import { useContext } from "react";
import { UserContext } from "App";
import Modal from "@mui/material/Modal";
import "./Coupons.css";
import {
  SkipUserFun,
  // AddedCustomerData,
  createB2CcustomerApi,
  addCustomer,
  dataRetriveWhenPageRefresh,
  getAllCoupons,
} from "config/Services";
// import { retailUserPayload } from "../../retailuserdetails/retailuserdetails";
import Spinner from "../../../../components/Spinner";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Cart } from "./Cart";
import Couponcard from "./components/couponsCard";
import Stack from "@mui/material/Stack";
import { FormControl, InputBase, Typography } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import breakpoints from "assets/theme/base/breakpoints";
import { alpha, styled } from "@mui/material/styles";
import { emit } from "react-native-react-bridge/lib/web";
import { useSelector } from "react-redux";
import { getMobilePos } from "./redux/Reducers/paginationReducer";
import useGetDevice from "../hooks/useGetDevice";
import StyledButton from "./components/custom/StyledButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StoreIcon from "@mui/icons-material/Store";
import { useSnackbar } from "../hooks/SnackbarProvider";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useDispatch } from "react-redux";
import { allProductsRenderType } from "./redux/Actions/paginationActions";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

export const Coupons = ({ setRenderType }) => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const [customerName, setCustomerName] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [addModelLoader, setAddModelLoader] = useState(false);
  const [skipModelLoader, setSkipModelLoader] = useState(false);
  const { color } = useContext(UserContext);
  const { setCartItems, setCartTotalQty } = useContext(UserContext);
  const { setCartId } = useContext(UserContext);
  const { setSubTotal } = useContext(UserContext);
  const { setTotal } = useContext(UserContext);
  const { setCgst } = useContext(UserContext);
  const { setSgst, saleMode, setCess } = useContext(UserContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(localStorage.getItem("CartId") ? false : true);
  const [setCustomerMobile] = useState(
    JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber || ""
  );
  const isMobilePos = useSelector(getMobilePos);

  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");
  const dispatch = useDispatch();

  //snackbar

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleOpen = () => setOpen(true);
  // useEffect for get the retail user details
  useEffect(() => {
    if (localStorage.getItem("CartId")) {
      let cartId = localStorage.getItem("CartId");
      dataRetriveWhenPageRefresh(cartId).then((res) => {
        setCartId(res?.data?.data?.data?.cartId);
        //dispatch(addcoupon())
        setCartItems(res?.data?.data?.data?.cartProducts);
        setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
        setCgst(res?.data?.data?.data?.billing?.cgst);
        setSgst(res?.data?.data?.data?.billing?.sgst);
        setCess(res?.data?.data?.data?.billing?.totalCessAmount);
        setSubTotal(res?.data?.data?.data?.billing?.subtotal);
        setTotal(res?.data?.data?.data?.billing?.totalCartValue);
      });
    }
  }, []);

  const retailPayload = {
    userName: null,
    userId: null,
    mobileNo: null,
    createdBy: retailUserLocalStorageData?.firstName,
    locationId: locId || "",
    sourceId: orgId || "",
    loggedInUser: retailUserLocalStorageData?.uidx,
    sourceLocationId: locId || "",
    sourceType: "RETAIL",
    sourceApp: saleMode === "delivery" ? "PALLET_RETAIL" : "PALLET_POS",
    destinationId: orgId || "",
    destinationLocationId: locId || "",
    destinationType: "RETAIL",
    comments: null,
    sessionId: sessionId || null,
    orderType: saleMode === "delivery" ? "B2C_ORDER" : "POS_ORDER",
    subOrderType: isMobile ? "MPOS_ORDER" : "POS_ORDER",
    licenseId: licenseId || null,
    hoId: null,
    channel: "POS",
  };
  const handleClose = () => {
    setSkipModelLoader(true);
    SkipUserFun(retailPayload)
      .then((res) => {
        const customer_details = {
          name: null,
          mobileNumber: null,
          uidx: null,
          whatsapp: false,
        };
        setCartId(res?.data?.data?.cartId);
        setCartItems(res?.data?.data?.cartProducts);
        setCartTotalQty(res?.data?.data?.billing?.quantity);
        setCgst(res?.data?.data?.billing?.cgst);
        setSgst(res?.data?.data?.billing?.sgst);
        setCess(res.data.data.billing.totalCessAmount);
        setSubTotal(res?.data?.data?.billing?.subtotal);
        setTotal(res?.data?.data?.billing?.totalCartValue);
        setOpen(false);
        localStorage.setItem("CartId", res?.data?.data?.cartId);
        localStorage.setItem("customer_details", JSON.stringify(customer_details));
        isMobilePos &&
          emit({
            type: "localData",
            data: {
              CartId: res.data.data.cartId,
              customer_details: customer_details,
            },
          });
        setSkipModelLoader(false);
        setCustomerMobile("");
      })
      .catch((err) => {});
  };

  // add customer Functionality implemented
  const addCustomerFun = () => {
    let addCustomerPayload = {
      mobile: customerMobileNumber,
      firstName: customerName,
    };
    if (customerMobileNumber.length !== 10) {
      showSnackbar("Enter valid credentials", "error");
    } else {
      addCustomer(addCustomerPayload).then((res) => {
        setAddModelLoader(true);
        let customerUidxData = {
          uidx: res?.data?.data?.uidx,
          phoneNumber: customerMobileNumber,
          name: customerName,
          organizationId: orgId,
          createdBy: retailUserLocalStorageData?.uidx,
          platform: "POS"
        };
        /*
        AddedCustomerData(customerUidxData)
        */
        createB2CcustomerApi(customerUidxData)
          .then((res) => {
            retailPayload.userName = customerName;
            retailPayload.mobileNo = customerMobileNumber;
            retailPayload.userId = customerUidxData?.uidx;
            SkipUserFun(retailPayload)
              .then((res) => {
                const customer_details = {
                  name: customerName,
                  mobileNumber: customerMobileNumber,
                  uidx: customerUidxData?.uidx,
                  whatsapp: whatsAppCheck,
                };
                setCartId(res?.data?.data?.cartId);
                setCartItems(res?.data?.data?.cartProducts);
                setCartTotalQty(res?.data?.data?.billing?.quantity);
                setCgst(res?.data?.data?.billing?.cgst);
                setSgst(res?.data?.data?.billing?.sgst);
                setCess(res.data.data.billing.totalCessAmount);
                setSubTotal(res?.data?.data?.billing?.subtotal);
                setTotal(res?.data?.data?.billing?.totalCartValue);
                setOpen(false);
                retailPayload.userName = null;
                retailPayload.mobileNo = null;
                retailPayload.userId = null;
                localStorage.setItem("CartId", res?.data?.data?.cartId);
                localStorage.setItem("customer_details", JSON.stringify(customer_details));
                isMobilePos &&
                  emit({
                    type: "localData",
                    data: {
                      CartId: res.data.data.cartId,
                      customer_details: customer_details,
                    },
                  });
                setCustomerName("");
                setCustomerMobileNumber("");
                setAddModelLoader(false);
              })
              .catch((err) => {
                setAddModelLoader(false);
              });
          })
          .catch((err) => {});
      });
    }
  };

  //apply coupon code api---
  const cart_id = localStorage.getItem("CartId");
  const [couponsData, setCouponsData] = useState([]);
  const [loader, setLoader] = useState(true);

  //get all coupons api
  // const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));

  useEffect(() => {
    const payload = {
      applicableProductType: [],
      applicableBrand: [],
      applicableLocation: [],
      couponCode: [],
      orgId: orgId,
      orgLocId: locId,
      userType: "END_USER",
      channel: "POS",
    };
    getAllCoupons(payload)
      .then((res) => {
        showSnackbar("Success All coupons", "success");
        const newCoupon = res?.data?.data?.coupon?.map((item) => {
          return { ...item, applied: false, loader: false };
        });
        setCouponsData(newCoupon);
        setLoader(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  }, []);

  return (
    <Box p={1}>
      <Box onClick={() => dispatch(allProductsRenderType(""))} className="backBtn-wrapper">
        <ArrowBackIosNewIcon className="paymentPageBackBtn" />
        <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0.65rem 0.5rem" }}>
          Available coupons
        </p>
      </Box>
      {loader ? (
        <Spinner />
      ) : (
        <Stack direction="column" justifyContent="flex-start" spacing={2}>
          {couponsData?.length === 0 && <div className="coupon-container-I">No Coupon Code</div>}
          {couponsData?.map((item, index) => (
            <Couponcard item={item} key={index} />
          ))}
        </Stack>
      )}
    </Box>
  );
};
